import React, { useState, useEffect } from 'react'
import queryString from "qs"
import { Button, Pagination } from "antd"
import ItemErrorFilters from "./filters/ItemColorSystemFilters"
import ItemErrorTable from "./table/ItemColorSystemTable"
import { Link } from "react-router-dom"
import { _convertObject } from "../../../helpers/convertObject"
import { listBatchItemError, exportBatchItemError } from "../../../services/api/3dApi"
import {createJobExport} from '../../../helpers/createJobExport'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'

function ItemColorSystemPage() {
    const [filters, setFilters] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [items, setItems] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(50)

    async function getBatchesError() {
        try {
            setLoading(true)
            setError('')

            const newFilter = Object.assign({}, {
                created_from: !!filters.created_at ? filters.created_at.from : '',
                created_to: !!filters.created_at ? filters.created_at.to : '',
                error_from: !!filters.error_date ? filters.error_date.from : '',
                error_to: !!filters.error_date ? filters.error_date.to : '',
                error_type: 'print',
                product_type: filters.product_types,
                error_style: filters.error_style,
                error_detail: 'sai_he_mau'
            })

            const query = queryString.stringify({ ..._convertObject(newFilter), page, limit })

            const { data: response } = await listBatchItemError(query)

            const { success, data, error } = response

            if (!success) {
                setLoading(false)
                setItems([])
                setTotal(0)
                return setError(error)
            }

            setLoading(false)
            setItems(data.items)
            setTotal(data.total)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    function _handleChangeInput(field, value) {
        setFilters({
            ...filters,
            [field]: value
        })
        setPage(1)
    }

    function _handleShowSizeChange(current, size) {
        setLimit(size)
        setPage(1)
    }

    function _handleChangeProductType(value) {
        setFilters({
            ...filters,
            product_types: value
        })
        setPage(1)
    }

    function _handleChangeDate(filtersValue) {
        setFilters({
            ...filtersValue
        })
        setPage(1)
    }

    function _handlePageChange(page) {
        setPage(page)
    }

    async function _exportItemError() {
        try {
            const newFilter = Object.assign({}, {
                created_from: !!filters.created_at ? filters.created_at.from : '',
                created_to: !!filters.created_at ? filters.created_at.to : '',
                error_from: !!filters.error_date ? filters.error_date.from : '',
                error_to: !!filters.error_date ? filters.error_date.to : '',
                error_type: 'print',
                error_style: filters.error_style,
                error_detail: 'sai_he_mau'
            })
            if(!!filters.product_types && !!filters.product_types.length) newFilter.product_type = filters.product_types
            // const query = queryString.stringify({ ...newFilter })
            // window.open(exportBatchItemError(query))
            const { data: res } = await exportBatchItemError({...newFilter})
            if(typeof res !== 'string'){
                const { success, message: mess, data } = res
                if(!success) throw new Error(mess)
            
                if(Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            }else{
                if(res) downloadFileFromData(res, { filename: `error-item-color-system${moment().format('HH_mm_DD_MM_YYYY')}.csv` })
            }
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    useEffect(() => {
        getBatchesError()
        // eslint-disable-next-line
    }, [page, limit, filters])

    return (
        <div className='ItemColorSystemPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách lô items lỗi hệ màu</h3>

                            <div className="Right">
                                <Button type='primary' className='mr-3' onClick={_exportItemError}>Export
                                    items</Button>
                                <Link to="/items-error" className="ant-btn ant-btn-default">Danh sách lô items lỗi QC</Link>
                            </div>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <ItemErrorFilters
                                loading={loading}
                                filters={filters}
                                onChangeInput={_handleChangeInput}
                                onChangeDate={_handleChangeDate}
                                onChangeProductType={_handleChangeProductType}
                            />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange} />
                        </div>
                        <div className="ItemColorSystemTableContainer">
                            <ItemErrorTable
                                items={items}
                                loading={loading}
                                onChangeProductType={_handleChangeProductType}
                            />
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showQuickJumper
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={_handlePageChange}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItemColorSystemPage
